import { Box, Grid, Typography } from '@mui/material';
import infuserGatewayImg from '@/assets/product/data-infuser-gateway.png';

const DataInfuserComponentGateWay: React.FC = () => {
  return (
    <Box className="">
      <img src={infuserGatewayImg} className="company-desc-img" />
    </Box>
  );
};

export default DataInfuserComponentGateWay;
